import { AppBar as MaterialAppBar, AppBarProps } from '@material-ui/core'
import React from 'react'
import { classes } from '../../../utils/css'
import styles from './AppBar.module.css'

function AppBar(props: AppBarProps): JSX.Element {
  return (
    <MaterialAppBar
      {...props}
      className={classes(props.className || '', styles.appBar)}
    />
  )
}

export default AppBar
